import api from "../adapter/base";

export const login_service=(data)=>{
    return api.post('login',data);
}